import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import {
	EBallastRecordCode,
	TBallastBackendRecord,
} from "../../../../redux/app/ballast/@types";
import { logSelectors } from "../../../../redux/app/logs";
import { marpolSelectors } from "../../../../redux/app/marpol";
import { vesselSelectors } from "../../../../redux/app/vessel";
import { IStore } from "../../../../redux/store";
import AdditionalOperationPreview from "../ballast/previews/AdditionalOperationPreview";
import BallastOperationPreview from "../ballast/previews/BallastOperationPreview";
import DeballastOperationPreview from "../ballast/previews/DeballastOperationPreview";
import ExchangeOperationPreview from "../ballast/previews/ExchangeOperationPreview";
import InternalOperationPreview from "../ballast/previews/InternalOperationPreview";
import MARPOLRecordParticipantsView from "../_elements/ParticipantsView";
import BallastPreviewer from "../ballast/BallastPreviewer";
import BallastRecordParticipantsView from "../ballast/_elements/ParticipantsView";

type OwnProps = {
	disabled: boolean;
};
type BallastDocsProps = OwnProps;
function BallastDocs(props: BallastDocsProps & PropsFromRedux) {
	const { disabled, marpolDocs } = props;

	if (disabled)
		return (
			<div className="w-full h-64 text-gray-500 bg-gray-500 rounded-lg opacity-50">
				Disabled MARPOL DOCS
			</div>
		);

	if (marpolDocs.length === 0)
		return (
			<div className="flex flex-col flex-1 max-h-full mb-2">
				<div className="flex flex-row w-full max-h-full overflow-y-auto ws-scroll">
					<div className="flex-1 ">
						<h1 className="p-6 text-sm font-medium border border-gray-200 rounded-sm">
							No records found..
						</h1>
					</div>
				</div>
			</div>
		);

	return (
		<div className="w-full p-0 pt-6">
			<div className="mb-8">
				<h1 className="text-xl font-bold font-redhat-display">
					Ballast Water Management Operations
				</h1>
			</div>
			<div className="w-full bg-gray-100">
				<table className="w-full bg-gray-100">
					<thead>
						<tr className="bg-gray-100">
							<th>
								<div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap">
									Date <span className="invisible"> and Time (UTC)</span>
								</div>
							</th>
							<th>
								<div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
									Code
								</div>
							</th>
							<th>
								<div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
									Item
								</div>
							</th>
							<th>
								<div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
									Record of Operations
								</div>
							</th>
						</tr>
					</thead>
					<tbody>
						{marpolDocs.map((ballastRecord, index) => {
							return (
								<React.Fragment key={ballastRecord._rev}>
									<BallastPreviewer
										ballastRecord={ballastRecord}
										isPrint={false}
									/>
									<BallastRecordParticipantsView
										ballastRecord={ballastRecord}
										isSubmitterChiefOrMaster={false}
									/>
								</React.Fragment>
							);
						})}
					</tbody>
				</table>
			</div>
			<div className="px-3 py-5 mt-6 text-right">
				<span className="ml-auto text-sm font-medium text-gray-600">
					Powered by - <strong className="font-bold">Volteo Maritime</strong>
				</span>
			</div>
		</div>
	);
}

function mapStateToProps(store: IStore) {
	const logStore = logSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const marpolStore = marpolSelectors._getStore(store);

	return {
		areVesselsPresent: vesselSelectors.areVesselsPresent(store.app.vesselStore),
		filterForm: logSelectors.formForFilter(logStore),
		marpolDocs: marpolSelectors.getDocs(marpolStore) as TBallastBackendRecord[],
		miniVessels: vesselSelectors.getMiniVessels(
			vesselSelectors.getVessels(vesselStore)
		),
		jobToFilterLogs: logSelectors.jobToFilterLogs(logStore),
		jobToLoadSelectedLog: logSelectors.jobToLoadSelectedLog(logStore),
		jobToLoadVessels: vesselSelectors.jobToLoadVessels(vesselStore),
	};
}
function mapDispatchToProps(dispatch: Dispatch) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BallastDocs);
